import script from "./BookCapsule.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookCapsule.vue?vue&type=script&lang=ts&setup=true"

import "./BookCapsule.vue?vue&type=style&index=0&id=470b7918&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470b7918"]])

export default __exports__